import { Md5 } from 'ts-md5'

import {
  type CrossSellHorizontalSliderRequestParams,
  useCrossSellConfigContext,
} from '../../../cross-sell'
import { productAccessorAvailableProductWidgetType } from '../../model/productAccessor/productAccessorAvailableProductWidgetType'
import { productAccessorStockStatusIsAvailable } from '../../model/productAccessor/productAccessorStockStatusIsAvailable'
import { PRODUCT_TEMPLATES } from '../../model/productTemplates'
import { useProductPageContext } from '../productPageContext'

// eslint-disable-next-line max-statements -- the rule was disabled before a comment became required
export const useProductAvailableCrossSellSliderRequestParams = ():
  | CrossSellHorizontalSliderRequestParams
  | undefined => {
  const { widgets } = useCrossSellConfigContext()
  const { currentVariant, productTemplate } = useProductPageContext()

  const isAvailable = productAccessorStockStatusIsAvailable(currentVariant)
  const isRx = productTemplate === PRODUCT_TEMPLATES.RX
  const widgetType = productAccessorAvailableProductWidgetType({
    isAvailable,
    isRx,
  })
  if (!isAvailable) {
    const widgetId = widgets[widgetType]?.id

    if (!widgetId) {
      return undefined
    }

    return {
      productId: currentVariant.upid,
      visibleItemCount: 3,
      widgetId,
    }
  }

  if (isRx) {
    const widgetId = widgets[widgetType]?.id

    if (!widgetId) {
      return undefined
    }

    const encryptedProductId = Md5.hashStr(currentVariant.upid)

    return {
      cmUid: `cid-${encryptedProductId}`,
      emcid: encryptedProductId,
      productId: currentVariant.upid,
      visibleItemCount: 3,
      widgetId,
    }
  }

  const widgetId = widgets[widgetType]?.id

  if (!widgetId) {
    return undefined
  }

  return {
    productId: currentVariant.upid,
    visibleItemCount: 3,
    widgetId,
  }
}
